module.exports = __webpack_public_path__ + "img/Poorter_hotel-093.8f8ff776.jpg";